import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { JRCInputSelectExtended } from '../../Form/Input/JRCSelect/JRCInputSelectExtended';

export type EditorSelectOption = { label: string; value: string };
export type EditorSelectOptions = EditorSelectOption[];

export const EditorSelect = <T extends string>({
    label,
    options = [],
    initialValue,
    required,
    onChange,
}: {
    label: string;
    options: EditorSelectOptions;
    initialValue: string | undefined;
    required?: boolean;
    onChange: (value: T) => void;
}) => {
    const intl = useIntl();
    const defaultValue = options.find((o) => o.value === initialValue);
    const { control, watch } = useForm({
        defaultValues: { select: defaultValue !== undefined ? defaultValue : options[0] },
        criteriaMode: 'all',
    });

    useEffect(() => {
        const subscription = watch((data: any) => {
            onChange(data.select.value);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch, onChange]);

    return (
        <form>
            <JRCInputSelectExtended
                options={options}
                label={label}
                components={{
                    Option: (o) => <span>{intl.formatMessage({ id: o.option.label })}</span>,
                }}
                getSearch={(o) => intl.formatMessage({ id: o.label })}
                rules={{ required }}
                hideDeleteIcon={true}
                required={required}
                control={control}
                name={'select'}
                labelMargin={'0'}
            />
        </form>
    );
};
